<template>
  <div class="main-container">
    <HeaderElement />

    <div class="gallery__outer bg-gray">
      <div class="gallery__wrapper">
        <h1 class="gallery__headline">Galerie</h1>
        <template v-if="0 < libaries.length">
          <div v-for="libary in libaries" :key="libary.id" class="gallery__libary">
            <div class="gallery__libary-info">
              <div class="gallery__title">Mitgliedsnummer</div>
              <div class="gallery__id">{{ libary.id }}</div>
              <button @click="$router.push({ name: 'LibaryView', params: { id: libary.id } })"
                class="gallery__btn ht-btn ht-btn--outline ht-btn-md">Erfahren Sie mehr</button>
            </div>
            <div class="gallery__libary-books">
              <div v-for="product in libary.products" :key="product.id" class="gallery__libary-item">
                <img
                  :src="0 < product.images.length ? product.images[0].image_path : require('../assets/img/no-image.jpeg')" />
                <div class="gallery__libary-item-title">{{ product.book_info.title }}</div>
                <div class="gallery__libary-item-state">{{ bookConditionWording[product.condition] }}</div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <FooterMain />
    <OffCanvasMobileMenu />
  </div>
</template>

<script>
import HeaderElement from '@/components/HeaderElement'
import FooterMain from '../components/FooterMain'
import { apiUrl } from '@/config.js'
import OffCanvasMobileMenu from '@/components/OffCanvasMobileMenu'
import ScrollTo from '@/components/mixins/scrollTo.js'

export default {
  name: 'app',
  components: {
    HeaderElement,
    FooterMain,
    OffCanvasMobileMenu,
  },
  mixins: [ScrollTo],
  computed: {
    bookConditionWording() {
      return {
        1: 'Sehr schlecht',
        2: 'Schlecht',
        3: 'Gebrauchsspuren',
        4: 'Gut',
        5: 'Ausgezeichnet'
      }
    }
  },
  data() {
    return {
      libaries: [],
      mail: {
        subject: 'Zentralregister-Zugang',
      }
    }
  },
  async mounted() {
    const data = await this.$axios.get(`${apiUrl}libaries/public`)
    if (200 === data.status) {
      this.libaries = data.data.user
    }
  },
}
</script>

<style lang="scss">
@use '../assets/scss/_variabls' as vars;

.gallery {
  &__outer {
    margin-top: 8rem;
    padding: 3rem 0;
  }

  &__wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 1rem;
  }

  &__headline {
    margin-bottom: 2rem;
  }

  &__libary {
    display: flex;
    flex-direction: column;
    width: 100%;
    flex-wrap: wrap;
    gap: .5rem;
    margin-bottom: 1rem;

    &-info {
      width: 100%;
      padding: 1rem;
      display: flex;
      flex-direction: column;
      border-radius: .5rem;
      background: vars.$theme-color--default-light;
    }

    &-books {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1rem;
      background: #fcfcfc;
      border-radius: .5rem;
      border: 1px solid #eeeeee;
      padding: 1rem;
    }

    &-item {
      text-align: center;
      border: 2px solid #d9dfef;
      padding: .5rem;
      border-radius: .5rem;

      &>img {
        width: 100%;
        aspect-ratio: 1 / 1;
        object-fit: cover;
        border-radius: .5rem;
      }

      &-title {
        color: #000;
        font-weight: 300;
        font-size: 1.25rem;
      }

      &-state {
        color: vars.$theme-color--default;
        font-weight: 100;
        font-size: 1rem;
      }
    }
  }

  &__title {
    font-size: 1.25rem;
    line-height: 12px;
    color: #fff;
    font-weight: 100;
  }

  &__id {
    font-size: 1.5rem;
    color: #fff;
    margin-bottom: .75rem;
    font-weight: 400;
  }

  &__btn {
    border: 2px solid #fff;
    color: #fff;
  }
}

@media #{vars.$tablet-up} {
  .gallery {
    &__wrapper {
      width: 100%;
      margin: auto;
      display: flex;
    }

    &__libary {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      max-height: 300px;

      &-info {
        max-width: 30%;
        align-items: center;
        justify-content: center;
      }

      &-books {
        display: flex;
        background: #fcfcfc;
        border-radius: .5rem;
        border: 2px solid #eeeeee;
        overflow-x: auto;
        overflow-y: hidden;
        flex-grow: 1;
        gap: 1rem;
        padding: 1rem;
      }

      &-item {
        flex: 0 0 200px;
        padding: 0;
        border: none;
        width: 30%;

        &>img {
          border: 2px solid #d9dfef;
        }
      }
    }
  }
}

@media #{vars.$laptop-device} {
  .gallery {
    &__wrapper {
      width: 80%;
    }
  }
}

@media #{vars.$xlmax-up} {
  .gallery {
    &__wrapper {
      width: 60%;
    }
  }
}
</style>